// extracted by mini-css-extract-plugin
module.exports = {"backgroundWhite":"Layout_backgroundWhite__obCOi","background":"Layout_background__2byeY Layout_backgroundWhite__obCOi"};